<template>
  <div
    class="result-item-container d-flex justify-space-between align-center rounded card-shadow gap-2 pa-2 pa-md-3"
    :class="isMobile ? 'text-nowrap overflow-y-auto' : ''"
    :style="cssVars"
  >
    <material-thumbnail :code="productSKU" :name="productName">
      <v-btn
        v-if="isMobile"
        class="mt-2"
        :class="{ 'btn-pr': isPRChannel, 'btn-dt': isDTChannel }"
        small
        @click="onAdd"
      >
        Agregar
      </v-btn>
    </material-thumbnail>

    <v-btn
      v-if="!isMobile"
      :class="{ 'btn-pr': isPRChannel, 'btn-dt': isDTChannel }"
      small
      @click="onAdd"
    >
      Agregar
    </v-btn>
  </div>
</template>

<script>
  import MaterialThumbnail from '@/components/materialSnapshot/MaterialThumbnail.vue';
  import { getProductMainImage } from '@/repositories/ProductFiles';

  import { mapGetters } from 'vuex';

  export default {
    name: 'SearchProductResultItem',

    components: { MaterialThumbnail },
    props: {
      product: { type: Object, required: true },
      height: { type: Number, default: 100 },
    },
    data: () => ({
      imageURL: undefined,
    }),
    computed: {
      ...mapGetters('auth', ['channel']),
      isPRChannel() {
        return this.channel === 'PR';
      },
      isDTChannel() {
        return this.channel === 'DT';
      },
      productSKU() {
        return this.product.MATNR.slice(-6);
      },
      productName() {
        return this.product.ARKTX;
      },
      cssVars() {
        return {
          '--height': `${this.height}px`,
        };
      },
    },
    async mounted() {
      const { image } = await getProductMainImage(this.productSKU);
      this.imageURL = image.path;
    },
    methods: {
      onAdd() {
        this.$emit('select', {
          sku: this.productSKU,
          name: this.productName,
          imageURL: this.imageURL,
        });
      },
    },
  };
</script>

<style scoped>
  .result-item-container {
    height: var(--height);
  }

  .btn-pr {
    color: white !important;
    background-color: #005eb0 !important;
  }
  .btn-dt {
    color: white !important;
    background-color: #c82333 !important;
  }
</style>
